module.exports = __webpack_public_path__ + "static/88-1-fb3206d3a9caf62a61659c7379e685d2.jpg";